<ng-template #nameCell let-side="side">
  <div class="t1-tsmd-namecell">
    @for (player of side?.participant_details; track playerIndex; let playerIndex = $index) {
      <span class="t1-tsmd-player">
        @if (get_flag(side, false, playerIndex); as flagSrc) {
          <img class="t1-tsmd-flag t1-tsmd-flag--player" [src]="flagSrc" alt="" stupaLogoTone />
        }
        <!-- Real Member Association/Club code from the side's `selected_parents`,
             falling back to the name-derived tag only when the event has no
             displayable entity configured (what `playerAbbr()` is for). -->
        @if (entityAbbr(side, playerIndex) || playerAbbr(player?.name); as playerChip) {
          <span class="t1-tsmd-name-row">
            <span class="t1-tsmd-entity-chip t1-tsmd-entity-chip--sm">{{ playerChip }}</span>
            <span class="t1-tsmd-name" [class.forfeited]="isParticipantForfeited(side)">{{ subDlgPlayerName(player?.name ?? '') }}</span>
          </span>
        } @else {
          <span class="t1-tsmd-name" [class.forfeited]="isParticipantForfeited(side)">{{ subDlgPlayerName(player?.name ?? '') }}</span>
        }
      </span>
    }
  </div>
</ng-template>

<div class="t1-tsmd" role="dialog" aria-modal="true" aria-labelledby="t1TsmdTitle" (click)="closeDialog.emit()">
  <div class="t1-tsmd-panel" (click)="$event.stopPropagation()">
    <div class="t1-tsmd-hd">
      <div class="t1-tsmd-hd-text">
        <span class="t1-tsmd-label">{{ 'team_match_details' | translate }}</span>
        <div class="t1-tsmd-title" id="t1TsmdTitle">
          <span class="t1-tsmd-team" [class.forfeited]="teamAForfeited">
            @if (teamFlagA) {
              <img class="t1-tsmd-flag t1-tsmd-flag--team" [src]="teamFlagA" alt="" stupaLogoTone />
            }
            <span class="t1-tsmd-team-lbl">
              @if (playerAbbr(teamNameA); as teamChipA) {
                <span class="t1-tsmd-entity-chip t1-tsmd-entity-chip--sm">{{ teamChipA }}</span>
              }
              <span class="t1-tsmd-team-txt">{{ teamNameA }}</span>
            </span>
          </span>
          <span class="t1-tsmd-score-pill">
            <span>{{ teamAScore }}</span><span class="t1-tsmd-score-sep">-</span><span>{{ teamBScore }}</span>
          </span>
          <span class="t1-tsmd-team" [class.forfeited]="teamBForfeited">
            @if (teamFlagB) {
              <img class="t1-tsmd-flag t1-tsmd-flag--team" [src]="teamFlagB" alt="" stupaLogoTone />
            }
            <span class="t1-tsmd-team-lbl">
              @if (playerAbbr(teamNameB); as teamChipB) {
                <span class="t1-tsmd-entity-chip t1-tsmd-entity-chip--sm">{{ teamChipB }}</span>
              }
              <span class="t1-tsmd-team-txt">{{ teamNameB }}</span>
            </span>
          </span>
        </div>
        @if (subDlgDate || subDlgTime) {
          <div class="t1-tsmd-meta">
            @if (subDlgDate) { <span>{{ 'date' | translate }}: {{ subDlgDate | date:'EEE, d MMM' }}</span> }
            @if (subDlgTime) { <span>{{ 'time' | translate }}: {{ subDlgTime | date:'h:mm a' }}</span> }
          </div>
        }
      </div>
      <button type="button" class="t1-tsmd-close" (click)="closeDialog.emit()" [attr.aria-label]="'close' | translate">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
      </button>
    </div>

    @if (tabs.length > 0) {
      <div class="t1-tsmd-tabs">
        @for (tab of tabs; track $index) {
          <button type="button" class="t1-tsmd-tab" [class.on]="tab.active" (click)="tabSelect.emit($index)">
            {{ tab.type === 'leg' ? (('leg' | translate) + ' ' + tab.number) : ('golden' | translate) }}
          </button>
        }
      </div>
    }

    <div class="t1-tsmd-body">
      @if (loading) {
        <!-- Reuses the real content's own wrapper classes (`.t1-tsmd-table-wrap`/`.t1-tsmd-cards`)
             so the existing `$t1-bp-mobile` responsive toggle between them (desktop table vs.
             phone cards) applies here for free — only one of the two is ever visible, exactly
             like the real content below. -->
        <div class="t1-tsmd-table-wrap" aria-hidden="true">
          <table class="t1-tsmd-table">
            <tbody>
              <tr *ngFor="let _ of t1TsmdSkeletonRows">
                <td><span class="t1-tsmd-skel t1-tsmd-skel-num"></span></td>
                <td><span class="t1-tsmd-skel t1-tsmd-skel-name"></span></td>
                <td class="t1-tsmd-td-vs"></td>
                <td><span class="t1-tsmd-skel t1-tsmd-skel-name"></span></td>
                <td><span class="t1-tsmd-skel t1-tsmd-skel-result"></span></td>
                <td><span class="t1-tsmd-skel t1-tsmd-skel-result"></span></td>
                <td><span class="t1-tsmd-skel t1-tsmd-skel-result"></span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="t1-tsmd-cards" aria-hidden="true">
          @for (_ of t1TsmdSkeletonRows; track $index) {
            <div class="t1-tsmd-card">
              <div class="t1-tsmd-card-hd">
                <span class="t1-tsmd-skel t1-tsmd-skel-idx"></span>
                <span class="t1-tsmd-skel t1-tsmd-skel-tot"></span>
              </div>
              <div class="t1-tsmd-skel-card-side">
                <span class="t1-tsmd-skel t1-tsmd-skel-name"></span>
                <span class="t1-tsmd-skel t1-tsmd-skel-pts"></span>
              </div>
              <div class="t1-tsmd-skel-card-side">
                <span class="t1-tsmd-skel t1-tsmd-skel-name"></span>
                <span class="t1-tsmd-skel t1-tsmd-skel-pts"></span>
              </div>
            </div>
          }
        </div>
      } @else {
        @if (subMatches.length > 0) {
          <div class="t1-tsmd-table-wrap">
            <table class="t1-tsmd-table">
              <colgroup>
                <col class="t1-tsmd-col-num" />
                <col class="t1-tsmd-col-team" />
                <col class="t1-tsmd-col-vs" />
                <col class="t1-tsmd-col-team" />
                <col class="t1-tsmd-col-result" />
                <col class="t1-tsmd-col-score" />
                <col class="t1-tsmd-col-total" />
              </colgroup>
              <thead>
                <tr>
                  <th class="t1-tsmd-th-num">#</th>
                  <th class="t1-tsmd-th-team">{{ teamNameA }}</th>
                  <!-- Spacer over the body's "vs" divider column: the two team
                       names either side already say what it separates, so
                       labelling it again only repeated the word down the header. -->
                  <th class="t1-tsmd-th-vs" scope="col" aria-hidden="true"></th>
                  <th class="t1-tsmd-th-team">{{ teamNameB }}</th>
                  <th class="t1-tsmd-th-result">{{ 'result' | translate }}</th>
                  <th class="t1-tsmd-th-score">{{ 'score' | translate }}</th>
                  <th class="t1-tsmd-th-total">{{ 'total_team_score' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (sub of subMatches; track sub.id; let i = $index) {
                  <tr>
                    <td class="t1-tsmd-th-num">
                      <span class="t1-tsmd-num">
                        <span class="t1-tsmd-dot" [class.done]="subMatchStatusClass(sub) === 'done'" [class.live]="subMatchStatusClass(sub) === 'live'"></span>
                        <span>{{ i + 1 }}</span>
                        @if (sub?.is_golden_match) {
                          <svg class="t1-tsmd-golden" width="13" height="13" viewBox="0 0 14 14" fill="none"
                            xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <rect width="14" height="14" rx="1.66667" />
                            <path
                              d="M8.70916 6C8.64666 5.80871 8.56428 5.63731 8.462 5.4858C8.36162 5.33239 8.24136 5.2017 8.10121 5.09375C7.96295 4.9858 7.80575 4.90341 7.62962 4.84659C7.45348 4.78977 7.2603 4.76136 7.05007 4.76136C6.70537 4.76136 6.39193 4.85038 6.10973 5.02841C5.82753 5.20644 5.6031 5.46875 5.43643 5.81534C5.26977 6.16193 5.18643 6.58712 5.18643 7.09091C5.18643 7.5947 5.27072 8.01989 5.43928 8.36648C5.60784 8.71307 5.83606 8.97538 6.12393 9.15341C6.41181 9.33144 6.73568 9.42045 7.09553 9.42045C7.42886 9.42045 7.72242 9.34943 7.97621 9.20739C8.23189 9.06345 8.43075 8.8608 8.5728 8.59943C8.71674 8.33617 8.78871 8.02652 8.78871 7.67045L9.00462 7.71591H7.25462V7.09091H9.47053V7.71591C9.47053 8.19508 9.36825 8.61174 9.16371 8.96591C8.96106 9.32008 8.68075 9.5947 8.3228 9.78977C7.96674 9.98295 7.55765 10.0795 7.09553 10.0795C6.58037 10.0795 6.12772 9.95833 5.73757 9.71591C5.34931 9.47348 5.04628 9.12879 4.82848 8.68182C4.61257 8.23485 4.50462 7.70455 4.50462 7.09091C4.50462 6.63068 4.56617 6.21686 4.68928 5.84943C4.81428 5.48011 4.99041 5.16572 5.21768 4.90625C5.44496 4.64678 5.7139 4.44792 6.0245 4.30966C6.33511 4.1714 6.67696 4.10227 7.05007 4.10227C7.35689 4.10227 7.64287 4.14867 7.90803 4.24148C8.17507 4.33239 8.41276 4.46212 8.62109 4.63068C8.83132 4.79735 9.00651 4.99716 9.14666 5.23011C9.28681 5.46117 9.3834 5.7178 9.43643 6H8.70916Z" />
                          </svg>
                        }
                      </span>
                    </td>
                    <td [class.win]="isSideWinner(sub, 0)">
                      <ng-container *ngTemplateOutlet="nameCell; context: { side: sub?.participants?.[0] }"></ng-container>
                    </td>
                    <td class="t1-tsmd-td-vs">{{ 'vs' | translate }}</td>
                    <td [class.win]="isSideWinner(sub, 1)">
                      <ng-container *ngTemplateOutlet="nameCell; context: { side: sub?.participants?.[1] }"></ng-container>
                    </td>
                    <td class="t1-tsmd-td-result">
                      @if (hasSubMatchSetScores(sub)) {
                        <div class="t1-tsmd-sets">
                          @for (score of sub?.participants?.[0]?.points; track setIndex; let setIndex = $index) {
                            @if (isSubMatchSetPlayed(sub, setIndex)) {
                              <span class="t1-tsmd-set">
                                <b [class.win]="isSubMatchSetWonBySide(sub, 0, setIndex)">{{ score }}</b>@if (sub?.participants?.[0]?.tie_sets?.[setIndex] > 0 && sub?.participants?.[1]?.tie_sets?.[setIndex] > 0) {<sup>{{ sub.participants[0].tie_sets[setIndex] }}</sup>}<span class="t1-tsmd-set-sep">-</span><b [class.win]="isSubMatchSetWonBySide(sub, 1, setIndex)">{{ sub?.participants?.[1]?.points?.[setIndex] }}</b>@if (sub?.participants?.[0]?.tie_sets?.[setIndex] > 0 && sub?.participants?.[1]?.tie_sets?.[setIndex] > 0) {<sup>{{ sub.participants[1].tie_sets[setIndex] }}</sup>}
                              </span>
                            }
                          }
                        </div>
                      } @else {
                        <span class="t1-tsmd-dash">—</span>
                      }
                    </td>
                    <td class="t1-tsmd-td-score">{{ hasSubMatchSideTotal(sub, 0) ? subMatchSideTotal(sub, 0) : '—' }}<span class="t1-tsmd-set-sep">-</span>{{ hasSubMatchSideTotal(sub, 1) ? subMatchSideTotal(sub, 1) : '—' }}</td>
                    <td class="t1-tsmd-td-total">{{ subDlgRunningTotals[i].a }}<span class="t1-tsmd-set-sep">-</span>{{ subDlgRunningTotals[i].b }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Phone layout: the 7-column table cannot fit a 375px viewport (it
               is 620px wide before padding), so the same boards render as
               cards — each side one row, its own score box on the right, the
               way the reference home drawer shows a sub-match score. Only one
               of the two is ever displayed; see the `$t1-bp-mobile` block. -->
          <div class="t1-tsmd-cards">
            @for (sub of subMatches; track sub.id; let i = $index) {
              <div class="t1-tsmd-card" [class.is-live]="subMatchStatusClass(sub) === 'live'">
                <div class="t1-tsmd-card-hd">
                  <span class="t1-tsmd-card-idx">{{ i + 1 }}</span>
                  @if (sub?.is_golden_match) {
                    <svg class="t1-tsmd-golden" width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <rect width="14" height="14" rx="1.66667" />
                      <path d="M8.70916 6C8.64666 5.80871 8.56428 5.63731 8.462 5.4858C8.36162 5.33239 8.24136 5.2017 8.10121 5.09375C7.96295 4.9858 7.80575 4.90341 7.62962 4.84659C7.45348 4.78977 7.2603 4.76136 7.05007 4.76136C6.70537 4.76136 6.39193 4.85038 6.10973 5.02841C5.82753 5.20644 5.6031 5.46875 5.43643 5.81534C5.26977 6.16193 5.18643 6.58712 5.18643 7.09091C5.18643 7.5947 5.27072 8.01989 5.43928 8.36648C5.60784 8.71307 5.83606 8.97538 6.12393 9.15341C6.41181 9.33144 6.73568 9.42045 7.09553 9.42045C7.42886 9.42045 7.72242 9.34943 7.97621 9.20739C8.23189 9.06345 8.43075 8.8608 8.5728 8.59943C8.71674 8.33617 8.78871 8.02652 8.78871 7.67045L9.00462 7.71591H7.25462V7.09091H9.47053V7.71591C9.47053 8.19508 9.36825 8.61174 9.16371 8.96591C8.96106 9.32008 8.68075 9.5947 8.3228 9.78977C7.96674 9.98295 7.55765 10.0795 7.09553 10.0795C6.58037 10.0795 6.12772 9.95833 5.73757 9.71591C5.34931 9.47348 5.04628 9.12879 4.82848 8.68182C4.61257 8.23485 4.50462 7.70455 4.50462 7.09091C4.50462 6.63068 4.56617 6.21686 4.68928 5.84943C4.81428 5.48011 4.99041 5.16572 5.21768 4.90625C5.44496 4.64678 5.7139 4.44792 6.0245 4.30966C6.33511 4.1714 6.67696 4.10227 7.05007 4.10227C7.35689 4.10227 7.64287 4.14867 7.90803 4.24148C8.17507 4.33239 8.41276 4.46212 8.62109 4.63068C8.83132 4.79735 9.00651 4.99716 9.14666 5.23011C9.28681 5.46117 9.3834 5.7178 9.43643 6H8.70916Z" />
                    </svg>
                  }
                  <span class="t1-tsmd-card-tot">
                    <span class="t1-tsmd-card-tot-lbl">{{ 'total_team_score' | translate }}</span>
                    {{ subDlgRunningTotals[i].a }}<span class="t1-tsmd-set-sep">-</span>{{ subDlgRunningTotals[i].b }}
                  </span>
                  <span class="t1-tsmd-card-st" [class]="'is-' + subMatchStatusClass(sub)">
                    {{ (subMatchStatusClass(sub) === 'live' ? 'live' : subMatchStatusClass(sub) === 'done' ? 'completed' : 'upcoming') | translate }}
                  </span>
                </div>

                @for (sideIndex of sides; track sideIndex) {
                  <div class="t1-tsmd-card-side"
                    [class.is-win]="isSideWinner(sub, sideIndex)"
                    [class.is-loser]="isSideWinner(sub, sideIndex === 0 ? 1 : 0)">
                    <ng-container *ngTemplateOutlet="nameCell; context: { side: sub?.participants?.[sideIndex] }"></ng-container>
                    <span class="t1-tsmd-pts"
                      [class.win]="isSideWinner(sub, sideIndex)"
                      [class.live]="subMatchStatusClass(sub) === 'live'">{{ hasSubMatchSideTotal(sub, sideIndex) ? subMatchSideTotal(sub, sideIndex) : '—' }}</span>
                  </div>
                }

                @if (hasSubMatchSetScores(sub)) {
                  <div class="t1-tsmd-card-sets">
                    <div class="t1-tsmd-sets">
                      @for (score of sub?.participants?.[0]?.points; track setIndex; let setIndex = $index) {
                        @if (isSubMatchSetPlayed(sub, setIndex)) {
                          <span class="t1-tsmd-set">
                            <b [class.win]="isSubMatchSetWonBySide(sub, 0, setIndex)">{{ score }}</b>@if (sub?.participants?.[0]?.tie_sets?.[setIndex] > 0 && sub?.participants?.[1]?.tie_sets?.[setIndex] > 0) {<sup>{{ sub.participants[0].tie_sets[setIndex] }}</sup>}<span class="t1-tsmd-set-sep">-</span><b [class.win]="isSubMatchSetWonBySide(sub, 1, setIndex)">{{ sub?.participants?.[1]?.points?.[setIndex] }}</b>@if (sub?.participants?.[0]?.tie_sets?.[setIndex] > 0 && sub?.participants?.[1]?.tie_sets?.[setIndex] > 0) {<sup>{{ sub.participants[1].tie_sets[setIndex] }}</sup>}
                          </span>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <div class="t1-tsmd-empty">
            <stupa-empty-state purpose="no-records" [title]="'no_sub_matches_found' | translate" />
          </div>
        }
      }
    </div>
  </div>
</div>
